import React, { useEffect, useState } from "react";
import {
    TrackingContainer,
    SearchWrapper,
    Input,
    Button,
    UserDetails,
    Table,
    TableRow,
    TableCell,
    Status,
    Heading,
    StepWrapper,
} from "./styles";
import { toast } from "react-toastify";
import event from "../../services/event";
import PaymentStep from "../../components/PaymentStep";
import payment from "../../services/payment";
import TicketSelection from "../../components/TicketSelectionStep";
import { useLocation } from "react-router-dom";

const EnrollmentStatusPage = () => {
    const [search, setSearch] = useState("");
    const [userData, setUserData] = useState(null);

    const [clientSecret, setClientSecret] = useState(null);

    const [productList, setProductList] = useState([]);
    const [step, setStep] = useState(1);
    const [ticketData, setTicketData] = useState([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const cpf = queryParams.get("cpf");

    const handleSearch = async () => {
        try {
            const response = await event.getAllPersonByEvent(1, { cpf: search });
            if (!response || !response?.data) {
                throw new Error("Erro ao buscar dados.");
            }

            setUserData(response?.data?.data[0]);

            if (response?.data?.data[0]?.payment_status === "paid") {
                setStep(3);
            }
        } catch (error) {
            toast.error(error.message || "Erro ao buscar dados do inscrito.");
        }
    };

    const handleTicketSelection = async (selectedTickets) => {
        setTicketData(selectedTickets);
        try {
            await startPayment(userData.id, selectedTickets);
            setStep(2);
        } catch (error) {
            console.log(error);
            toast.error("Erro ao processar. Tente novamente.");
        }
    };

    const startPayment = async (personId, tickets) => {
        try {
            const itens = tickets.map((t) => ({ id: t.id, amount: t.unit_amount, quantity: t.quantity }));
            const response = await payment.createPaymentIntent({
                itens: itens,
                currency: "brl",
                personData: { id: personId, purchase: JSON.stringify(itens) },
            });

            setClientSecret(response.data.clientSecret);
        } catch (error) {
            console.log(error);
            toast.error("Erro ao iniciar pagamento.");
        }
    };

    useEffect(() => {
        const getProducts = async () => {
            const products = await payment.getPrices("DEMO");
            if (products && products?.data && products?.data?.data) {
                setProductList(products?.data?.data);
            } else {
                toast.error("Ocorreu um erro ao buscar dados");
            }
        };

        getProducts();
    }, []);

    useEffect(() => {
        const fetchDados = async (data) => {
            try {
                const response = await event.getAllPersonByEvent(1, { cpf: data });
                if (!response || !response?.data) {
                    throw new Error("Erro ao buscar dados.");
                }

                setUserData(response?.data?.data[0]);

                if (response?.data?.data[0]?.payment_status === "paid") {
                    setStep(3);
                }
            } catch (error) {
                toast.error(error.message || "Erro ao buscar dados do inscrito.");
            }
        };

        if (cpf) {
            setSearch(cpf);
            fetchDados();
        }
    }, [cpf]);

    return (
        <TrackingContainer>
            <SearchWrapper>
                <Input
                    type="text"
                    placeholder="Digite o CPF"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <Button onClick={handleSearch}>Buscar</Button>
            </SearchWrapper>

            {userData && (
                <>
                    <UserDetails>
                        <Table>
                            <tbody>
                                <TableRow>
                                    <TableCell>Nome:</TableCell>
                                    <TableCell>{userData.name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Email:</TableCell>
                                    <TableCell>{userData.email}</TableCell>
                                </TableRow>
                                {/* <TableRow>
                                    <TableCell>Ingressos:</TableCell>
                                    <TableCell>{userData.tickets}</TableCell>
                                </TableRow> */}
                                <TableRow>
                                    <TableCell>Status:</TableCell>
                                    <TableCell>
                                        <Status status={userData.payment_status ? userData.payment_status : "pending"}>
                                            {userData.payment_status ? userData.payment_status : "pending"}
                                        </Status>
                                    </TableCell>
                                </TableRow>
                            </tbody>
                        </Table>
                    </UserDetails>

                    {userData && step !== 3 && <Heading>Conclua sua Inscrição</Heading>}
                    {userData && (
                        <StepWrapper>
                            {step === 1 && (
                                <TicketSelection productList={productList} onSubmit={handleTicketSelection} />
                            )}
                            {step === 2 && clientSecret && (
                                <PaymentStep
                                    clientSecret={clientSecret}
                                    clientEmail={userData.email}
                                    clientName={userData.name}
                                    itens={ticketData}
                                    clientCpf={userData.cpf}
                                />
                            )}
                            {step === 3 && <Heading>Inscrição e pagamento concluídos!</Heading>}
                        </StepWrapper>
                    )}
                </>
            )}
        </TrackingContainer>
    );
};

export default EnrollmentStatusPage;
